<template>
  <p class="text-sm/6 font-semibold text-brand-700">
    {{ label }}
  </p>
</template>

<script setup lang="ts">
import type { EyebrowProps } from 'types/section'

const { label } = defineProps<EyebrowProps>()
</script>
